import { section } from '@/neon';
import { add } from '@fluorescent/dom';

import scrollIntoView from '@/lib/scrollIntoView';
import isFirstSectionOnHomepage from '@/lib/homePage';

section('image-hero', {
  onLoad() {
    this.scrollAnimation = scrollIntoView(this.container);

    if (isFirstSectionOnHomepage(this.container)) {
      add(this.container, 'first-full-height');
    }
  },

  onUnload() {
    this.scrollAnimation.unload();
  },
});
